import { Navigate } from 'react-router-dom';

import { pathToSankey, useLoadedSankey } from '../utils/routes';

const SankeyMainExamplePage: React.FC = () => {
  const sankey = useLoadedSankey();
  return <Navigate to={pathToSankey(sankey.id)} replace />;
};

export default SankeyMainExamplePage;
